// #region imports
import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import fonts from '../fonts';
// #endregion

const MuiDialogTitle = {
  styleOverrides: {
    root: ({ theme }: { theme: Theme}) => ({
      ...fonts.header,
      fontSize: 24,
      lineHeight: 1,
      fontWeight: 700,
      color: theme.palette.text.secondary,
      padding: '20px 35px 16px',
      [theme.breakpoints.up('md')]: {
        fontSize: 30,
        padding: '30px 35px 30px'
      },
      '& + div.MuiDialogContent-root': {
        paddingTop: 0,
        [theme.breakpoints.up('md')]: {
          paddingTop: 0
        }
      }
    })
  }
} as Components['MuiDialogTitle'];

export default MuiDialogTitle;
